import { ExceptionUtils } from "#src/utils/exception";
import { useMutation } from "@tanstack/react-query";
import { toast } from "@validereinc/common-components";
import { FormSubmissionType } from "@validereinc/domain";
import {
  bulkExportFormSubmissionAsPDF,
  exportFormSubmissionAsPDF,
} from "./exportFormSubmissionPDF";

export const useExportFormSubmissionAsPDF = (
  opts: Parameters<typeof exportFormSubmissionAsPDF>[1]
) => {
  return useMutation<
    string | unknown,
    unknown,
    Parameters<typeof exportFormSubmissionAsPDF>[0]
  >({
    mutationFn: async (formSubmission) =>
      exportFormSubmissionAsPDF(formSubmission, opts),
    onSuccess: (fileName) => {
      toast.push({
        intent: "success",
        description: `PDF ${fileName as string} successfully exported.`,
      });
    },
    onError: (err, formSubmission) => {
      ExceptionUtils.reportException(err, "error", {
        hint: `Failed to export PDF for form submission ${formSubmission.id}.`,
      });
      toast.push({
        intent: "error",
        description: "Failed to export PDF.",
      });
    },
  });
};

export const useBulkExportFormSubmissionAsPDF = () => {
  return useMutation<
    string | unknown,
    unknown,
    {
      formSubmissions: FormSubmissionType[];
      worker: Worker;
      onProgress: (progress: number, blobUrl: string) => void;
    }
  >({
    mutationFn: async ({ formSubmissions, worker, onProgress }) =>
      bulkExportFormSubmissionAsPDF(worker, formSubmissions, onProgress),
    onSuccess: () => {
      toast.push({
        intent: "success",
        description: `PDFs successfully exported.`,
      });
    },
    onError: (err) => {
      ExceptionUtils.reportException(err, "error", {
        hint: `Failed to bulk export PDF for form submissions.`,
      });
      toast.push({
        intent: "error",
        description: "Failed to export PDF.",
      });
    },
  });
};
